import { css } from 'styled-components'
import { getPaletteColor } from 'pcln-design-system'

export default css`
  svg[color='blue'],
  #traveler-control-panel svg[color='gray'] {
    color: ${getPaletteColor('primary.base')};
  }

  #typeahead-list {
    div:nth-child(1),
    div:hover {
      color: #fff;
      background-color: ${getPaletteColor('primary.base')};

      svg {
        color: #fff;
      }
    }
  }

  body:not(&)
    #react-aria-modal-dialog:not([aria-label='Reload modal dialog opened']) {
    div[color='blue'],
    svg[color='blue'],
    #traveler-control-panel svg[color='gray'] {
      color: ${getPaletteColor('primary.base')};
    }

    #typeahead-list {
      div:nth-child(1),
      div:hover {
        color: #fff;
        background-color: ${getPaletteColor('primary.base')};

        svg {
          color: #fff;
        }
      }
    }

    div[class*='Modal__Inner'] > div:first-child > div {
      background-color: ${getPaletteColor('primary.base')};
    }
  }

  body:not(&) reach-portal div[class*='ModalDialog__StyledModal'] {
    &
      > div:first-child
      > div:first-child
      > div:first-child:not([class*='PhotoTheater__DarkerScrim']) {
      background-color: ${getPaletteColor('primary.base')};
    }

    & div[class*='RoomInfoModal__BoxWithBorder'] > div > div:first-child {
      background-color: ${getPaletteColor('primary.base')};
    }

    span[class*='GuestScoreBreakdown__OverallScoreValue'] {
      background-color: ${getPaletteColor('primary.base')};
    }

    span[class*='GuestScoreBreakdown__OverallScoreValue']:after {
      border-right-color: ${getPaletteColor('primary.base')};
    }

    div[class*='ReviewRow__OverallScore'] {
      background-color: ${getPaletteColor('primary.base')};
    }

    div[color='blue'] {
      color: ${getPaletteColor('primary.base')};
    }

    button[class*='SeeMoreContent__ExpandableButton'] {
      color: ${getPaletteColor('primary.base')};
    }
  }

  div.loadingBanner__spinningIconGroup > div:nth-child(2n + 1),
  div.hotelDetail__spinningIcon > div {
    & > div {
      border-color: ${getPaletteColor('primary.base')};
      border-right-color: transparent;
    }

    & svg {
      color: ${getPaletteColor('primary.base')};
    }
  }

  div[color='blue'],
  span[color='blue'] {
    color: ${getPaletteColor('primary.base')};
  }

  span[class*='HotelHeading__HotelNameText']:hover {
    color: ${getPaletteColor('primary.base')};
  }

  div[class*='HotelsList__BoxSizingContentBox'] + div,
  div[class*='FlightsList__FlyListingsBox'] > div {
    button {
      background-color: transparent !important;
      color: ${getPaletteColor('primary.base')};
    }

    svg[color='#007aff'] {
      color: ${getPaletteColor('primary.base')};
    }

    div[color='#007aff'] {
      border-color: ${getPaletteColor('primary.base')};
      border-right-color: transparent;
    }
  }

  div[class*='NoHotelAvailable'] a {
    color: ${getPaletteColor('primary.base')};
    border-bottom-color: ${getPaletteColor('primary.base')};
  }

  div.itinerary-bar.show-details {
    & > div:first-child {
      background-color: ${getPaletteColor('primary.base')};
    }

    svg:not([color='white']) {
      color: ${getPaletteColor('primary.dark')};
    }

    & > div:nth-child(2) {
      background-image: linear-gradient(
        135deg,
        ${getPaletteColor('primary.base')} 0%,
        rgb(232, 56, 27) 100%
      );

      svg,
      div {
        color: #fff;
      }

      button {
        color: #fff;
        box-shadow: inset 0 0 0 2px #fff;
      }
    }
  }

  .pclnFilter__buttonGroup {
    border: 1px solid ${getPaletteColor('primary.dark')};

    button {
      color: ${getPaletteColor('primary.dark')};
      background-color: transparent !important;

      &:hover {
        color: ${getPaletteColor('primary.dark')} !important;
        background-color: transparent !important;
      }
    }
  }

  div[class*='HighlightedFeatureText__StyledRatingBadge'] {
    background-color: ${getPaletteColor('primary.base')};
  }

  button[class*='RoomInfo__MoreDetailsButton'] {
    color: ${getPaletteColor('primary.base')};
  }

  button[class*='DetailPanel__MoreInfoLink'] {
    color: ${getPaletteColor('primary.base')};
  }

  button[class*='StickyNavBar__Tab'] {
    color: ${getPaletteColor('primary.base')};
  }

  button[class*='GuestReviewsLink__ReviewsButton'] {
    color: ${getPaletteColor('primary.base')};
  }

  div[class*='setInfoList__Score'],
  div[class*='BarGraph__AnimationBox'] {
    background-color: ${getPaletteColor('primary.base')};
  }

  div[class*='HotelsList__StyledHotelsList'] > div[class*='HoverCard'] {
    & > div:first-child:not([class*='HotelListing']) {
      border-color: ${getPaletteColor('primary.base')};

      & > div:first-child {
        background-color: ${getPaletteColor('primary.base')};
      }
    }
  }

  div[class*='FlightsList__FlyListingsBox'] div[class*='HoverCard'] {
    & > div[class*='sc-'] {
      border-color: ${getPaletteColor('primary.base')};

      & > div:first-child {
        background-color: ${getPaletteColor('primary.base')};
      }
    }

    .mobile-checkbox__fake-box:hover {
      border-color: ${getPaletteColor('primary.base')};
    }

    .icon-utility-checkLight,
    .icon-utility-checkLight:before {
      color: ${getPaletteColor('primary.base')};
    }
  }

  div[class*='HotelListingMap__MapShadowBox'] > div:first-child {
    background-color: ${getPaletteColor('primary.base')};
  }

  #back-header-back-link {
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }
  }

  #HotelDetail-Tooltip,
  #HotelDetail-Tooltip button,
  button[class*='Mosaic__SeeAllButton']:hover {
    background-color: ${getPaletteColor('primary.dark')};
  }

  #HotelDetail-Tooltip:after {
    border-bottom-color: ${getPaletteColor('primary.dark')};
    border-left-color: ${getPaletteColor('primary.dark')};
  }

  div[class*='MessageBanner__PaddedBanner'] button {
    background-color: transparent !important;
  }

  .fly-search-listings .pcln1-exd-container {
    .pcln1-exd-banner {
      background-color: ${getPaletteColor('primary.base')};

      span {
        background-color: transparent;
      }
    }

    div[color='#007aff'] {
      color: ${getPaletteColor('primary.base')};
    }
  }

  div[class*='PlaceholderItineraryCard__ProductCard'] {
    div[color='#007aff'] {
      border-color: ${getPaletteColor('primary.base')};
      border-right-color: transparent;
    }

    svg[color='#007aff'] {
      color: ${getPaletteColor('primary.base')};
    }
  }

  div[class*='FiltersContainer__StyledWrapper'] {
    .rc-slider {
      color: ${getPaletteColor('primary.base')};

      .rc-slider-track {
        background-color: ${getPaletteColor('primary.base')} !important;
      }

      .rc-slider-handle {
        border-color: ${getPaletteColor('primary.base')} !important;
      }
    }
  }

  div[class*='TripSummaryTimeline__Pipe'] {
    border-color: ${getPaletteColor('primary.base')};
  }

  div[class*='StyledItineraryBar__Scroller'] {
    &
      > div
      > div:nth-child(2)
      > div
      > div
      > div:last-child
      > div:last-child:not([class*='PlaceholderItineraryCard__ProductCard']):not([class*='TripSummaryGroundTransfer__RelativeCard'])
      > div {
      border-color: ${getPaletteColor('primary.base')};

      & > div:first-child {
        background-color: ${getPaletteColor('primary.base')};
      }
    }
  }

  button[class*='ScrollToMapLink__ButtonWithLineHeight'] {
    color: ${getPaletteColor('primary.base')};
  }

  button[class*='MapModalLink__MapAndLocationButton'] {
    color: ${getPaletteColor('primary.base')};
  }

  span[class*='GuestReviewsModalLink__OverallScoreValue'] {
    background-color: ${getPaletteColor('primary.base')};
  }

  span[class*='GuestReviewsModalLink__OverallScoreValue']:after {
    border-right-color: ${getPaletteColor('primary.base')};
  }

  span[class*='GuestReviewsModalLink__GuestReviewsLinkText'] {
    color: ${getPaletteColor('primary.base')};
  }

  span[class*='MobilePoliciesModalLink__PoliciesText'] {
    color: ${getPaletteColor('primary.base')};
  }

  div[class*='Modal__StyledHeader'] {
    background-color: ${getPaletteColor('primary.base')};
  }

  button[class*='ChipButton__ChipStyleButton'] {
    background-image: none;
  }

  button[class*='InlinePriceBar__PriceBarButton'] {
    background-color: ${getPaletteColor('primary.base')};
  }

  button[class*='StickyNavBar__StyledButton'] {
    background-color: ${getPaletteColor('primary.base')};
  }

  button[class*='BottomBar__StyledButton'] {
    background-color: ${getPaletteColor('primary.base')};
  }

  div[class*='RetailFlightView__FlySearchListings'] button[color='primary'] {
    background-color: ${getPaletteColor('primary.base')};
    background-image: linear-gradient(
      135deg,
      ${getPaletteColor('primary.base')} 0%,
      rgb(232, 56, 27) 100%
    );
  }
`
